import React from "react"
import { useTranslation } from "react-i18next"
import { Link } from "react-router-dom"

export const FeatureDeactivatedPage = () => {
    const { t } = useTranslation()

    return (
        <div>
            <h2 className="p-0 text-center sm:text-left">{t("view:error.feature_deactivated.title")}</h2>
            <p className="mb-20 text-center sm:text-left">{t("view:error.feature_deactivated.message")}</p>

            <div className="text-center sm:text-left">
                <Link to={"/"}>{t("nav:go_back_to_homepage")}</Link>
            </div>
        </div>
    )
}
